module.exports = __webpack_public_path__ + "img/information.6ec99194.svg";